module.exports = __webpack_public_path__ + "static/pc_mb_casestudy_consumerapp-9c7b1f055ca4de688dbb9c84e9b3b167.jpg";